import angular from 'angular';

angular.module('folkeuni').factory('PaymentService', function () {
  var payment = this;

  payment.openPaymentWindow = function (checkout) {
    
    
    var form = document.createElement('form');
    form.method = "POST";
    form.action = checkout.url;
  
    var params = checkout.parameters;

    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];
  
        form.appendChild(hiddenField);
      }
    }
  
    document.body.appendChild(form);
    form.submit();
  }


  return payment;
});